import React, { useEffect } from 'react'
import { useImmer } from 'use-immer'
import { useDispatch } from 'react-redux'
import Rodal from 'rodal'

import {
    getTechnologies,
    getTechnologyStats,
    resetTechnologyBrowserState,
} from 'store/technologies/actions'

const TechnologyBrowserStats = ({ stats, searchText }) => {
    const dispatch = useDispatch()
    const [state, setState] = useImmer({
        viewAllTags: false,
        viewAllVendors: false,
        // currentFilterVendor,
        currentFilter: null,
    })

    useEffect(() => {
        if (state.currentFilter === null) {
            return
        } else if (searchText !== '') {
            setState((draft) => {
                draft.currentFilter = null
            })
        }
    }, [searchText])

    const fitlerByTags = (item) => {
        if (state.currentFilter === item) {
            setState((draft) => {
                draft.currentFilter = null
            })
            dispatch(getTechnologies())
        } else {
            setState((draft) => {
                draft.currentFilter = item
            })
            dispatch(
                getTechnologies(`?filter_fields=tags&filter_values=${item}`)
            )
        }
    }

    const fitlerByVendor = (item) => {
        if (state.currentFilter === item) {
            setState((draft) => {
                draft.currentFilter = null
                draft.viewAllVendors = false
            })
            dispatch(getTechnologies())
        } else {
            setState((draft) => {
                draft.currentFilter = item
                draft.viewAllVendors = false
            })
            dispatch(
                getTechnologies(`?filter_fields=vendor&filter_values=${item}`)
            )
        }
    }

    const renderTagsSection = () => {
        const top10tags = Object.keys(stats?.top_10_by_tags || {})
        return (
            <React.Fragment>
                <div className="text-xl font-bold">Top 10 Tags</div>

                <div className=" mt-2 flex flex-wrap items-center ">
                    {top10tags?.length > 0 ? (
                        top10tags.map((item, index) => (
                            <React.Fragment key={index}>
                                <div
                                    className="w-auto mx-1"
                                    onClick={() => {
                                        fitlerByTags(item)
                                    }}
                                >
                                    <div className="flex flex-wrap items-center my-2">
                                        <div
                                            className={
                                                state.currentFilter === item
                                                    ? 'w-auto border border-primary-500 bg-primary-400 text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md rounded-md'
                                                    : 'w-auto border border-primary-500 hover:bg-primary-400 hover:text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md rounded-md'
                                            }
                                        >
                                            <span className="">{item}</span>
                                            <span className="ml-2 font-bold">
                                                {stats?.top_10_by_tags[item]}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                    ) : (
                        <div className="py-1 px-1">No results</div>
                    )}
                </div>
                <div
                    className="mt-1 mb-1 text-primary-500 hover:underline cursor-pointer"
                    onClick={() => {
                        setState((draft) => {
                            draft.viewAllTags = true
                        })
                    }}
                >
                    View More
                </div>
            </React.Fragment>
        )
    }

    const renderVendorSection = () => {
        const top10Vendors = Object.keys(stats?.top_10_by_vendor || {})
        return (
            <React.Fragment>
                <div className="text-xl font-bold">Top 10 Vendors</div>

                <div className="mt-2 flex flex-wrap items-center ">
                    {top10Vendors?.length > 0 ? (
                        top10Vendors.map((item, index) => (
                            <React.Fragment key={index}>
                                <div
                                    className="w-auto mx-1"
                                    onClick={() => {
                                        fitlerByVendor(item)
                                    }}
                                >
                                    <div className="flex flex-wrap items-center my-2">
                                        <div
                                            className={
                                                state.currentFilter === item
                                                    ? 'w-auto border border-primary-500 bg-primary-400 text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md rounded-md'
                                                    : 'w-auto border border-primary-500 hover:bg-primary-400 hover:text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md rounded-md'
                                            }
                                        >
                                            <span className="">{item}</span>
                                            <span className="ml-2 font-bold">
                                                {stats?.top_10_by_vendor[item]}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </React.Fragment>
                        ))
                    ) : (
                        <div className="py-1 px-1">No results</div>
                    )}
                </div>
                <div
                    className="mt-1 mb-1 text-primary-500 hover:underline cursor-pointer"
                    onClick={() => {
                        setState((draft) => {
                            draft.viewAllVendors = true
                        })
                    }}
                >
                    View More
                </div>
            </React.Fragment>
        )
    }

    return (
        <div className="mt-4">
            <div>{renderTagsSection()}</div>
            <div className="mt-4">{renderVendorSection()}</div>

            <div>
                <Rodal
                    className="rodal-sort-container"
                    visible={state.viewAllTags}
                    onClose={() => {
                        setState((draft) => {
                            draft.viewAllTags = false
                        })
                    }}
                    customStyles={{
                        width: '90%',
                        height: '490px',
                    }}
                    closeMaskOnClick={true}
                    closeOnEsc={true}
                    animationType="enter"
                    showCloseButton={false}
                >
                    {' '}
                    <div className="top-toolbar mt-6 h-full">
                        <div className="px-4 text-xl font-bold text-center">
                            List of all tags with stats
                        </div>
                        <div className="my-8 flex flex-wrap items-center h-max-80-percent overflow-auto ">
                            {stats?.count_by_tags &&
                                Object.keys(stats.count_by_tags).map(
                                    (item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="w-auto my-2">
                                                <div
                                                    className="ml-2 px-2 py-1 border border-primary-500 hover:bg-primary-400 hover:text-white p-1  
													cursor-pointer leading-relaxed sm:text-base lg:text-md pl-2 rounded-md"
                                                    //   onClick={() => onStatClick('author', item)}
                                                >
                                                    {item}
                                                    <span class="pl-2 title-font font-bold sm:text-base lg:text-md ">
                                                        (
                                                        {
                                                            stats.count_by_tags[
                                                                item
                                                            ]
                                                        }
                                                        )
                                                    </span>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                )}
                        </div>
                    </div>
                </Rodal>

                <Rodal
                    className="rodal-sort-container"
                    visible={state.viewAllVendors}
                    onClose={() => {
                        setState((draft) => {
                            draft.viewAllVendors = false
                        })
                    }}
                    customStyles={{
                        width: '90%',
                        height: '490px',
                    }}
                    closeMaskOnClick={true}
                    closeOnEsc={true}
                    animationType="enter"
                    showCloseButton={false}
                >
                    {' '}
                    <div className="top-toolbar mt-6 h-full">
                        <div className="px-4 text-xl font-bold text-center">
                            List of all vendors with stats
                        </div>
                        <div className="my-8 flex flex-wrap items-center h-max-80-percent overflow-auto ">
                            {stats?.count_by_vendor &&
                                Object.keys(stats.count_by_vendor).map(
                                    (item, index) => (
                                        <React.Fragment key={index}>
                                            <div className="w-auto my-2">
                                                <div
                                                    className={
                                                        state.currentFilter ===
                                                        item
                                                            ? 'ml-2 px-2 py-1 border border-primary-500 bg-primary-400 text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md pl-2 rounded-md'
                                                            : 'ml-2 px-2 py-1 border border-primary-500 hover:bg-primary-400 hover:text-white p-1 cursor-pointer leading-relaxed sm:text-base lg:text-md pl-2 rounded-md'
                                                    }
                                                    onClick={() =>
                                                        fitlerByVendor(item)
                                                    }
                                                >
                                                    {item}
                                                    <span class="pl-2 title-font font-bold sm:text-base lg:text-md ">
                                                        (
                                                        {
                                                            stats
                                                                .count_by_vendor[
                                                                item
                                                            ]
                                                        }
                                                        )
                                                    </span>
                                                </div>
                                            </div>
                                        </React.Fragment>
                                    )
                                )}
                        </div>
                    </div>
                </Rodal>
            </div>
        </div>
    )
}

export default React.memo(TechnologyBrowserStats)
